import { useContext } from 'react';
import { Carousel2 } from '@intigral/ui';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { DetailedPoster, Text } from '@intigral/shared';
import h from '../../helpers/common';
import f from '../../helpers/formatter';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import { EVENT } from '../../contexts/MixpanelConstants';
import { STCPlayGames } from '@intigral/domain/lib/entity/interface/iBigScreenCmsMoods';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

const GAME_KEY = 'game';

export const GamesCarousel = (props) => {
    const { track }: { track: any } = useContext(MixpanelContext);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { isLoading, data: gamesData } = useQuery({
        queryKey: ['games'],
        enabled: true,
        queryFn: async () => {
            try {
                const commonService = container.resolve<ICustomConfigurationService>(
                    DI.SERVICES.ICustomConfigurationService
                );
                const response = await commonService.getGames();
                return response?.data || [];
            } catch (e) {
                return [];
            }
        },
        refetchOnWindowFocus: false,
    });

    const handleCardClick = (gameData: STCPlayGames, isDetailPage = false) => {
        if (gameData?.id) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set(GAME_KEY, btoa(gameData?.id?.toString()));
            navigate(`?${newParams.toString()}`);

            track(EVENT.STC_PLAY_GAMES_CAROUSEL.ITEM_CLICK, {
                'Screen Name': !isDetailPage ? h.getScreen() : 'STC Play Game Details',
                'Carousel Name': f.getComponentTitle(props.meta),
                'Carousel Type': 'STC Play Games',
                'Item Name': gameData?.name_en,
            });
        }
    };

    if (gamesData?.length <= 0) {
        return <></>;
    }

    return (
        <div data-test-id="games-carousel-container" className="container full-width">
            <SectionHeaderWithPagination
                data-test-id="games-carousel-header"
                title={f.getComponentTitle(props.meta)}
                className="paging"
                isLoading={isLoading}
            />
            <Carousel2
                data-test-id="games-carousel"
                isLoading={isLoading}
                swiperSettings={{
                    autoplay: false,
                    pagination: {
                        el: '.paging',
                        clickable: true,
                    },
                    slidesPerGroup: 1,
                    slidesPerView: 2,
                    breakpoints: {
                        560: {
                            slidesPerView: 3,
                            slidesPerGroup: 2,
                        },
                        768: {
                            slidesPerView: 4,
                            slidesPerGroup: 2,
                        },
                        924: {
                            slidesPerView: 4,
                            slidesPerGroup: 3,
                        },
                    },
                }}
            >
                {isLoading ? (
                    <DetailedPoster isLoading={isLoading} />
                ) : (
                    gamesData?.map((item, index) => {
                        return (
                            <DetailedPoster
                                key={`games-${index}-${item.id}`}
                                picture={item.img}
                                heading={
                                    <Text
                                        as="h4"
                                        variant="h4"
                                        alignment="center"
                                        margin="0"
                                        size={{ default: '14', md: '22' }}
                                    >
                                        {h.getLang() === 'ar' ? item.name_ar : item.name_en}
                                    </Text>
                                }
                                onClick={() => {
                                    handleCardClick(item);
                                }}
                            />
                        );
                    })
                )}
            </Carousel2>
        </div>
    );
};

export default GamesCarousel;
